import { Service } from '@roc/feature-app-core';

const url = {
  CLOSING_CONDITIONS_DASHBOARD: '/api/v1/taskV2/closingConditions/getClosingConditionDashboard',
};

export class ClosingConditionsDashboardService extends Service {
  getClosingConditions(
    tab: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      url.CLOSING_CONDITIONS_DASHBOARD,
      {
        tab,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }
}